import React from "react"
import {useTranslation} from "react-i18next"
import {RouteComponentProps, withRouter} from "react-router"
import {Button, Dialog, DialogActions, DialogTitle, Icon} from "@material-ui/core"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function GoBackSection(props: RouteComponentProps) {
    const {history} = props;
    const styles = useStyles();
    const [t] = useTranslation("common");
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const closeDialog = () => setDialogOpen(false);

    return (
        <div className={styles.container}>
            <Button color="primary"
                    startIcon={<Icon>arrow_back</Icon>}
                    onClick={() => setDialogOpen(true)}>
                {t("back")}
            </Button>
            <Dialog open={dialogOpen}
                    onClose={closeDialog}
                    PaperProps={{className: styles.dialog}}>
                <DialogTitle>{t("are_you_sure")}</DialogTitle>
                <DialogActions className={styles.actions}>
                    <Button color="secondary"
                            onClick={closeDialog}>{t("cancel")}</Button>
                    <Button color="primary"
                            variant="contained"
                            onClick={history.goBack}>{t("back")}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withRouter(GoBackSection)
